module.exports = __webpack_public_path__ + "static/media/Alert.728df683.svg";